import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-650b14ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "small-bg": "" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#14dcff","text-align":"center","font-size":"30px","font-weight":"600","position":"absolute","width":"100%"} }, "国振家具建模组问题跟踪", -1))
const _hoisted_3 = { style: {"color":"#14dcff","margin-left":"10px","position":"absolute","top":"50px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("统计时间： ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 至 ")
const _hoisted_6 = {
  "demo-bg": "",
  style: {"position":"absolute","top":"100px","left":"1%","bottom":"3%","width":"62%"}
}
const _hoisted_7 = { style: {"position":"relative","width":"100%","height":"100%"} }
const _hoisted_8 = {
  "color-green": "",
  "font-600": "",
  class: "content",
  bg: "~ dark/0"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "color-white": "",
  "font-300": ""
}, " 总数 ", -1))
const _hoisted_10 = {
  "color-green": "",
  "font-600": "",
  class: "content",
  bg: "~ dark/0"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "color-white": "",
  "font-300": ""
}, " 进行中 ", -1))
const _hoisted_12 = {
  "color-green": "",
  "font-600": "",
  class: "content",
  bg: "~ dark/0"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "color-white": "",
  "font-300": ""
}, " 待审核 ", -1))
const _hoisted_14 = {
  "color-green": "",
  "font-600": "",
  class: "content",
  bg: "~ dark/0"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "color-white": "",
  "font-300": ""
}, " 正常完成 ", -1))
const _hoisted_16 = {
  "color-green": "",
  "font-600": "",
  class: "content",
  bg: "~ dark/0"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "color-white": "",
  "font-300": ""
}, " 逾期完成 ", -1))
const _hoisted_18 = {
  "color-green": "",
  "font-600": "",
  class: "content",
  bg: "~ dark/0"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "color-white": "",
  "font-300": ""
}, " 逾期未完成 ", -1))
const _hoisted_20 = {
  "color-green": "",
  "font-600": "",
  class: "content",
  bg: "~ dark/0"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "color-white": "",
  "font-300": ""
}, " 待评价 ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_23 = {
  "demo-bg": "",
  style: {"position":"absolute","top":"150px","bottom":"10px"}
}
const _hoisted_24 = { style: {"position":"absolute","top":"20%","left":"870px","bottom":"5%","width":"20px"} }
const _hoisted_25 = { style: {"position":"absolute","top":"100px","left":"890px","bottom":"5%","right":"10px"} }
const _hoisted_26 = {
  "dv-bg": "",
  class: "floatleft",
  style: {"width":"47%","text-align":"center"}
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode("责任人")
const _hoisted_28 = {
  "dv-bg": "",
  class: "floatleft",
  style: {"width":"47%","text-align":"center"}
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("类型占比")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_31 = {
  "dv-bg": "",
  class: "floatleft",
  style: {"position":"absolute","top":"230px","width":"100%","bottom":"0px"}
}
const _hoisted_32 = {
  "dv-bg": "",
  style: {"padding":"20px"}
}
const _hoisted_33 = { style: {"position":"absolute","top":"20px","right":"20px","bottom":"20px","left":"20px","overflow":"auto"} }
const _hoisted_34 = { style: {"width":"100%","border-collapse":"collapse"} }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { style: {"position":"sticky","top":"0"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"color":"#fff","background":"#00baff","line-height":"30px"} }, [
    /*#__PURE__*/_createElementVNode("th", null, "序号"),
    /*#__PURE__*/_createElementVNode("th", null, "类型"),
    /*#__PURE__*/_createElementVNode("th", null, "数量")
  ])
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))

import { CirclePlus,Search } from '@element-plus/icons-vue';
	import { reactive,ref,onMounted,nextTick } from 'vue';
	import AddUser from '@/components/AddUser.vue';
	import { requestGjcsTj,requestDDDepartlist } from '@/api/xmApi';
	import { ElMessage } from 'element-plus';
	import { getScrollBarWidth } from 'element-plus/es/utils';
	import { requestMkzTj,requestMkzTjList } from '@/api/api'

	
export default /*#__PURE__*/_defineComponent({
  name: 'tjjianmo',
  setup(__props) {

	const startdate = ref('')
	const enddate = ref('')

	const zs = ref('')
	const jxz = ref('')
	const dsh = ref('')
	const zcwc = ref('')
	const yqwc = ref('')
	const yqwwc = ref('')
	const dpj = ref('')

	const jmtype = ref([])
	const operatorname = ref([])
	const list = ref([])
	//表格
	const config = reactive({
	header: ['类别', '标题','负责人', '审核人',  '截至时间','完成时间',  '状态'],
	data: [
	],
	index: true,
	carousel:'page',
	columnWidth: [50],
	align: ['center'],
	hoverPause:false,
	rowNum:20,
	})

	const mouseoverHandler = (e: any) => {
	console.log(e)
	}

	const clickHandler = (e: any) => {
	console.log(e)
	}
	//饼图1
	const conf1 = reactive({
  lineWidth: 24,
  radius:65,
  activeRadius:80,
  digitalFlopStyle: {
    fill: 'pink',fontSize: 16,
  },
  data: [],
})
	//饼图2
		const conf2 = reactive({
  lineWidth: 24,
  radius:65,
  activeRadius:80,
  digitalFlopStyle: {
    fill: 'pink',fontSize: 16,
  },
  data: [],
})
	//排行榜
	const config4 = reactive({
  data: [
    {
      name: '周口',
      value: 55,
    },
    {
      name: '南阳',
      value: 120,
    },
    {
      name: '西峡',
      value: 78,
    },
    {
      name: '驻马店',
      value: 66,
    },
    {
      name: '新乡',
      value: 80,
    },
    {
      name: '信阳',
      value: 45,
    },
    {
      name: '漯河',
      value: 29,
    },
  ],
  unit: '万元',
})
	const RowClassName = (row: any, index: any) => {
		console.log("111111",row,index,row.rowIndex)
  if (row.rowIndex % 2 === 0) {
      return 'warning-row';
    } else {
      return 'success-row';
    }
}
	//
	onMounted(()=>{
		loadDate()
	})
	
	const loadDate = () => {
		// startdate enddate
		requestMkzTj({
            startdate:startdate.value,
            enddate:enddate.value,
        }).then((res:any)=>{
            if(res.status === 1){
				zs.value = res.datalist.zs
				jxz.value = res.datalist.jxz
				dsh.value = res.datalist.dsh
				zcwc.value = res.datalist.zcwc
				yqwc.value = res.datalist.yqwc
				yqwwc.value = res.datalist.yqwwc
				dpj.value = res.datalist.dpj
				startdate.value = res.datalist.startdate
				enddate.value = res.datalist.enddate
				conf1.data=[]
				conf2.data=[]
				list.value=[]
				jmtype.value =res.datalist.jmtype
				operatorname.value =res.datalist.operatorname
				res.datalist.jmtype.forEach((item:any,index:any)=>{
					conf1.data.push({"name":item.name,"value":parseInt(item.c)})   
					list.value.push({"xh":index+1,"name":item.name,"value":parseInt(item.c)})
				})
				res.datalist.operatorname.forEach((item:any,index:any)=>{
					conf2.data.push({"name":item.name,"value":parseInt(item.c)})   
				})
				bdlist(0)
            }
        })
	}

	const btloadData = (tmplist: any) => { 
		list.value =[]
		tmplist.forEach((item:any,index:any)=>{
					list.value.push({"xh":index+1,"name":item.name,"value":parseInt(item.c)})
		})
	}

	const bdlist = (index0: any) => { 
		console.log(index0)
		requestMkzTjList({
            startdate:startdate.value,
            enddate:enddate.value,
			index:index0,
        }).then((res:any)=>{
            if(res.status === 1){
				config.data = []
				conf1.data=[]
				conf2.data=[]
				list.value=[]
				jmtype.value =res.datalist.jmtype
				operatorname.value =res.datalist.operatornamelist
				res.datalist.operatornamelist.forEach((item:any,index:any)=>{
					conf1.data.push({"name":item.name,"value":parseInt(item.c)})   
					list.value.push({"xh":index+1,"name":item.name,"value":parseInt(item.c)})
				})
				res.datalist.jmtype.forEach((item:any,index:any)=>{
					conf2.data.push({"name":item.name,"value":parseInt(item.c)})   
				})
				var ztstr = ["","进行中","关闭","待审核","完成"]
				res.datalist.list.forEach((item:any,index:any)=>{
					config.data.push([item.jmtype,item.tasktitle,item.operatorname,item.checkname,item.enddate,item.actime,ztstr[item.status]])   
				})
            }
        })
	}

return (_ctx: any,_cache: any) => {
  const _component_dv_decoration5 = _resolveComponent("dv-decoration5")!
  const _component_dv_decoration_9 = _resolveComponent("dv-decoration-9")!
  const _component_dv_decoration7 = _resolveComponent("dv-decoration7")!
  const _component_dv_scroll_board = _resolveComponent("dv-scroll-board")!
  const _component_dv_decoration4 = _resolveComponent("dv-decoration4")!
  const _component_dv_active_ring_chart = _resolveComponent("dv-active-ring-chart")!
  const _component_dv_button = _resolveComponent("dv-button")!
  const _component_dv_border_box8 = _resolveComponent("dv-border-box8")!
  const _component_dv_full_screen_container = _resolveComponent("dv-full-screen-container")!

  return (_openBlock(), _createBlock(_component_dv_full_screen_container, { style: {"background-color":"#1d1d1d"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_dv_decoration5, {
          dur: 3,
          style: {"width":"80%","height":"75px","margin":"0 auto"}
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "date",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startdate).value = $event)),
          onChange: loadDate
        }, null, 544), [
          [_vModelText, startdate.value]
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "date",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((enddate).value = $event)),
          onChange: loadDate
        }, null, 544), [
          [_vModelText, enddate.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              "dv-bg": "",
              class: "floatleft",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (bdlist(0)))
            }, [
              _createVNode(_component_dv_decoration_9, { style: {"width":"100px","height":"100px","color":"#4ade80"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(zs.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_dv_decoration7, { style: {"width":"100px","height":"30px","color":"#fff","font-size":"12px"} }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              "dv-bg": "",
              class: "floatleft",
              style: {"cursor":"pointer"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (bdlist(1)))
            }, [
              _createVNode(_component_dv_decoration_9, { style: {"width":"100px","height":"100px","color":"#4ade80"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(jxz.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_dv_decoration7, { style: {"width":"100px","height":"30px","color":"#fff","font-size":"12px"} }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              "dv-bg": "",
              class: "floatleft",
              style: {"cursor":"pointer"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (bdlist(2)))
            }, [
              _createVNode(_component_dv_decoration_9, { style: {"width":"100px","height":"100px","color":"#f8e50e"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(dsh.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_dv_decoration7, { style: {"width":"100px","height":"30px","color":"#fff","font-size":"12px"} }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              "dv-bg": "",
              class: "floatleft",
              style: {"cursor":"pointer"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (bdlist(3)))
            }, [
              _createVNode(_component_dv_decoration_9, { style: {"width":"100px","height":"100px","color":"#fd7215"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(zcwc.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_dv_decoration7, { style: {"width":"100px","height":"30px","color":"#fff","font-size":"12px"} }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              "dv-bg": "",
              class: "floatleft",
              style: {"cursor":"pointer"},
              onClick: _cache[6] || (_cache[6] = ($event: any) => (bdlist(4)))
            }, [
              _createVNode(_component_dv_decoration_9, { style: {"width":"100px","height":"100px","color":"#f60b0b"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(yqwc.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_dv_decoration7, { style: {"width":"120px","height":"30px","color":"#fff","font-size":"12px"} }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              "dv-bg": "",
              class: "floatleft",
              style: {"cursor":"pointer"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (bdlist(5)))
            }, [
              _createVNode(_component_dv_decoration_9, { style: {"width":"100px","height":"100px","color":"#f60b0b"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(yqwwc.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_dv_decoration7, { style: {"width":"120px","height":"30px","color":"#fff","font-size":"12px"} }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              "dv-bg": "",
              class: "floatleft",
              style: {"cursor":"pointer"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (bdlist(6)))
            }, [
              _createVNode(_component_dv_decoration_9, { style: {"width":"100px","height":"100px","color":"#f60b0b"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(dpj.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_dv_decoration7, { style: {"width":"120px","height":"30px","color":"#fff","font-size":"12px"} }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              })
            ]),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_dv_scroll_board, {
              config: config,
              style: {"width":"840px"},
              onMouseover: mouseoverHandler,
              onClick: clickHandler
            }, null, 8, ["config"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_dv_decoration4, {
          dur: 2,
          style: {"width":"5px","height":"95%"}
        })
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_dv_active_ring_chart, {
              config: conf1,
              style: {"height":"180px","margin":"0px auto"}
            }, null, 8, ["config"]),
            _createVNode(_component_dv_button, {
              style: {"width":"100px","margin":"0px auto"},
              onClick: _cache[9] || (_cache[9] = ($event: any) => (btloadData(operatorname.value))),
              border: "Border3",
              color: "#c8161d",
              "font-color": "#e18a3b"
            }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_dv_active_ring_chart, {
              config: conf2,
              style: {"height":"180px","margin":"0px auto"}
            }, null, 8, ["config"]),
            _createVNode(_component_dv_button, {
              style: {"width":"100px","margin":"0px auto"},
              onClick: _cache[10] || (_cache[10] = ($event: any) => (btloadData(jmtype.value))),
              border: "Border3",
              color: "#c8161d",
              "font-color": "#e18a3b"
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ]),
          _hoisted_30
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_dv_border_box8, {
              dur: 5,
              style: {"position":"relative"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("table", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: _normalizeClass({ 'tb1': index % 2 === 0, 'tb2': index % 2 === 1 })
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.xh), 1),
                            _createElementVNode("td", null, _toDisplayString(item.name), 1),
                            _createElementVNode("td", null, _toDisplayString(item.value), 1)
                          ], 2))
                        }), 256))
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _hoisted_36
        ])
      ])
    ]),
    _: 1
  }))
}
}

})